import dayjs from "dayjs";

export const printReceipt = (
  localIp,
  address,
  address1,
  city,
  gstNo,
  userPhone,
  nextInvNo,
  invNo,
  billDate,
  userDetails,
  customerName,
  userName,
  customerMobile,
  barCodeData,
  totalAmount,
  totalDisAmt,
  totalNetAmt,
  totalQty,
  base64Images,
  base64QR,
  totalGstData,
  ins,
  ins1,
  ins2,
  ins3,
  ins4,
  ins5,
  ins6
) => {
  var printer = null;
  var ePosDev = new window.epson.ePOSDevice();

  ePosDev.connect(localIp, 8008, cbConnect);

  function cbConnect(data) {
    if (data === "OK") {
      ePosDev.createDevice(
        "local_printer",
        ePosDev.DEVICE_TYPE_PRINTER,
        { crypto: true, buffer: false },
        cbCreateDevice_printer
      );
    } else {
      console.log("Connection failed:", data);
    }
  }

  function cbCreateDevice_printer(devobj, retcode) {
    if (retcode === "OK") {
      printer = devobj;
      executeAddedCode();
    } else {
      console.log("Device create failed:", retcode);
    }
  }

  async function executeAddedCode() {
    const lineWidth = 42;
    const showValue = (val) =>
      val && val !== "-" && String(val).trim() !== "" && val !== "undefined"
        ? val
        : "-";
    printer.addTextAlign(printer.ALIGN_CENTER);
    const loadImage = (base64, name) =>
      new Promise((resolve, reject) => {
        if (!base64) {
          reject(`${name} is empty`);
          return;
        }

        const img = new Image();

        img.onload = () => resolve(img);

        img.onerror = (e) => {
          console.error(`${name} load failed`, e);
          reject(`${name} invalid base64`);
        };

        // ✅ ENSURE PREFIX
        if (!base64.startsWith("data:image")) {
          img.src = `data:image/png;base64,${base64}`;
        } else {
          img.src = base64;
        }
      });
    let logoImg = null;
    let qrImg = null;

    try {
      logoImg = await loadImage(base64Images, "Logo Image");
    } catch (err) {
      console.warn("Logo skipped:", err);
    }

    try {
      qrImg = await loadImage(base64QR, "QR Image");
    } catch (err) {
      console.warn("QR skipped:", err);
    }
    if (logoImg) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const width = 200;
      const height = Math.round(width * (logoImg.height / logoImg.width));

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(logoImg, 0, 0, width, height);

      printer.addImage(
        ctx,
        0,
        0,
        width,
        height,
        printer.COLOR_1,
        printer.MODE_MONO,
        printer.HALFTONE_DITHER,
        1
      );

      printer.addFeedLine(1);
    }
    printer.addTextSize(2, 2); // Large font
    printer.addText(userName + "\n");
    printer.addTextSize(1, 1); // Reset font size

    printer.addText(address + "\n");
    printer.addText(address1 + "\n");
    printer.addText("PHONE NO: " + showValue(userPhone) + "\n");
    printer.addText("GSTIN: " + gstNo + "\n");
    printer.addFeedLine(1);

    // ==== TITLE ====
    printer.addText("========================================\n");
    printer.addTextFont(printer.FONT_C);
    printer.addTextAlign(printer.ALIGN_CENTER);
    printer.addTextSize(2, 1);
    // printer.addTextStyle(true, false, true, printer.COLOR_3);
    printer.addText("TAX INVOICE\n");
    // printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
    printer.addTextFont(printer.FONT_A);
    printer.addTextSize(1, 1);
    printer.addText("========================================\n");

    // ==== INVOICE INFO ====
    const invLabel = "INV NO   : ";
    const invValue = String(invNo ? invNo : nextInvNo);
    const invText = invLabel + invValue.padEnd(9, " ");

    const dateLabel = "DATE : ";
    const dateValue = billDate
      ? dayjs(billDate).format("DD-MMM-YYYY hh:mm A")
      : dayjs().format("DD-MMM-YYYY hh:mm A");
    const dateText = dateLabel + dateValue.padStart(11, " ");

    const spaceCounts = lineWidth - (invText.length + dateText.length);
    const space = " ".repeat(spaceCounts > 0 ? spaceCounts : 1);

    const line1 = invText + space + dateText;

    printer.addText(line1 + "\n");

    printer.addTextAlign(printer.ALIGN_LEFT);
    // printer.addText(line1 + "\n");
    printer.addText(
      "MOBILE   : " + (showValue(userDetails?.Mobileno) || "-") + "\n"
    );
    printer.addText(
      "CUST NAME: " + (showValue(userDetails?.Custname) || "-") + "\n"
    );
    printer.addText("------------------------------------------------\n");

    // ==== TABLE HEADER ====
    // printer.addTextStyle(true, false, false, printer.COLOR_BLACK);
    // printer.addTextFont(printer.FONT_C);
    // printer.addTextSize(2, 1);
    printer.addText("SNO PARTICULARS    QTY     RATE   DISC    AMOUNT\n");
    // printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
    // printer.addTextFont(printer.FONT_A);
    // printer.addTextSize(1, 1);
    printer.addText("------------------------------------------------\n");

    // ==== ITEMS ====
    barCodeData.forEach((item, index) => {
      const sno = (index + 1).toString().padEnd(4, " "); // SNO column
      const code = (item.DesignCode || "").substring(0, 14).padEnd(14, " "); // BARCODE max 12 chars
      const qty = String(item.stock).padStart(4, " "); // right-align QTY
      const rate = item.CPrice.toFixed(2).padStart(9, " "); // right-align RATE
      const disc = item.Disamt.toFixed(2).padStart(7, " "); // right-align DISC
      const amount = (item.stock * item.offer).toFixed(2).padStart(10, " "); // right-align AMOUNT

      // Main row (aligned with header)
      printer.addText(sno);
      printer.addTextStyle(true, false, false, printer.COLOR_BLACK);
      printer.addText(code);
      printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
      printer.addText(`${qty}${rate}${disc}${amount}\n`);

      // Second row: Product Name + HSN + SMCODE + GST
      const name = (item.ProdName || "").substring(0, 30).padEnd(30, " ");
      const size =
        item?.Prodsize && item.Prodsize !== "-" ? `SZ:${item.Prodsize}` : "";
      const hsnCode =
        item?.HSNCODE && item.HSNCODE !== "-" ? `HSN:${item.HSNCODE}` : "";
      const gst = item?.GST && Number(item.GST) > 0 ? `GST:${item.GST}%` : "";
      const smCode =
        item?.SMCODE && item.SMCODE !== "-" ? `SM:${item.SMCODE}` : "";
      const discPer = Number(item.Disper) > 0 ? `${Number(item.Disper)}%` : "";
      printer.addTextFont(printer.FONT_A);
      printer.addTextSize(1, 1);
      printer.addText(`    ${name}${discPer}\n`);
      printer.addTextFont(printer.FONT_C);
      printer.addTextSize(1, 1);

      // Third row: MRP + OFFER
      printer.addText(`     ${hsnCode} ${gst} ${smCode} ${size}\n`);
      // printer.addText(
      //   `    MRP:${item.CPrice?.toFixed(2) || "0.00"}        OFFER:${
      //     item?.offer?.toFixed(2) || "0.00"
      //   }\n`
      // );

      // Separator
      printer.addTextFont(printer.FONT_A);
      printer.addTextSize(1, 1);
      printer.addFeedLine(1);
    });
    printer.addText("------------------------------------------------\n");

    // ==== SUMMARY ====
    // printer.addTextAlign(printer.ALIGN_RIGHT);
    // printer.addText("ToT QTY : " + totalQty + "\n");
    // printer.addText("Total Amount : " + totalAmount.toFixed(2) + "\n");
    // printer.addText("Discount     : " + totalDisAmt.toFixed(2) + "\n");
    // printer.addTextStyle(true, false, false, printer.COLOR_BLACK);
    // printer.addText("Net Amount   : " + totalNetAmt.toFixed(2) + "\n");
    // printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
    const leftLabel = "TOT QTY : ";
    const leftValue = String(totalQty ?? 0);
    const leftText = leftLabel + leftValue.padEnd(10, " ");
    const rightLabel = "TOTAL AMOUNT : ";
    const rightValue = totalAmount.toFixed(2);
    const rightText = rightLabel + rightValue.padStart(12, " ");

    const spaceCount = lineWidth - (leftText.length + rightText.length);
    const spaces = " ".repeat(spaceCount > 0 ? spaceCount : 1);

    printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
    printer.addText(leftText + spaces + rightText + "\n");
    printer.addTextAlign(printer.ALIGN_RIGHT);
    printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
    printer.addText(
      "DISCOUNT : " + totalDisAmt.toFixed(2).padStart(12, " ") + "\n"
    );
    // printer.addTextStyle(true, false, false, printer.COLOR_BLACK);
    printer.addText(
      "NET AMOUNT : " + totalNetAmt.toFixed(2).padStart(12, " ") + "\n"
    );
    // printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
    printer.addFeedLine(2);

    const totals = totalGstData.reduce(
      (acc, row) => {
        acc.Basic_amt += row.Basic_amt;
        acc.CGST_AMT += row.CGST_AMT;
        acc.SGST_AMT += row.SGST_AMT;
        acc.NET_AMT += row.NET_AMT;
        return acc;
      },
      { Basic_amt: 0, CGST_AMT: 0, SGST_AMT: 0, NET_AMT: 0 }
    );

    printer.addTextFont(printer.FONT_C);
    printer.addTextAlign(printer.ALIGN_CENTER);
    printer.addTextSize(2, 1);
    // printer.addTextStyle(true, false, false, printer.COLOR_BLACK);
    printer.addText("GST SUMMARY\n");
    // printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
    printer.addTextAlign(printer.ALIGN_LEFT);
    printer.addTextFont(printer.FONT_C);
    printer.addTextSize(1, 1);
    printer.addText(
      "----------------------------------------------------------------\n"
    );
    printer.addText(
      "BASIC AMT    CGST(%)  CGST(AMT)    SGST(%)  SGST(AMT)    NET AMT\n"
    );
    // printer.addText("         ------------------------------         \n");
    // printer.addText("          %   CGST        %   SGST              \n");
    printer.addText(
      "----------------------------------------------------------------\n"
    );

    totalGstData.forEach((row) => {
      const line =
        row.Basic_amt.toFixed(2).padStart(9, " ") +
        String(row.CGST_RATE + "%").padStart(11, " ") +
        row.CGST_AMT.toFixed(2).padStart(11, " ") +
        String(row.SGST + "%").padStart(11, " ") +
        row.SGST_AMT.toFixed(2).padStart(11, " ") +
        row.NET_AMT.toFixed(2).padStart(11, " ");
      printer.addText(line + "\n");
    });

    // Totals row
    // const totalLine =
    //   totals.Basic_amt.toFixed(2).padEnd(10, " ") +
    //   "".padEnd(7, " ") +
    //   totals.CGST_AMT.toFixed(2).padEnd(8, " ") +
    //   "".padEnd(7, " ") +
    //   totals.SGST_AMT.toFixed(2).padEnd(8, " ") +
    //   totals.NET_AMT.toFixed(2).padEnd(10, " ");
    // printer.addText("------------------------------------------------\n");
    // printer.addText(totalLine + "\n");
    // printer.addText("------------------------------------------------\n");
    printer.addTextFont(printer.FONT_A);
    printer.addTextSize(1, 1);
    printer.addFeedLine(1);

    // ==== TERMS & CONDITIONS ====
    printer.addTextAlign(printer.ALIGN_CENTER);
    printer.addTextSize(1, 1);
    printer.addText("****Terms & Conditions****\n");
    printer.addFeedLine(1);
    printer.addTextAlign(printer.ALIGN_LEFT);
    printer.addTextStyle(false, false, false, printer.COLOR_BLACK);
    printer.addTextFont(printer.FONT_C);
    printer.addTextSize(1, 1);

    printer.addText(ins + "\n");
    printer.addText(ins1 + "\n");
    printer.addText(ins2 + "\n");
    printer.addText(ins3 + "\n");
    printer.addText(ins4 + "\n");
    printer.addText(ins5 + "\n");
    printer.addText(ins6 + "\n");
    printer.addTextFont(printer.FONT_A);
    printer.addFeedLine(1);
    printer.addTextAlign(printer.ALIGN_CENTER);
    if (qrImg) {
      const qrCanvas = document.createElement("canvas");
      const qrCtx = qrCanvas.getContext("2d");

      const qrWidth = 300;
      const qrHeight = Math.round(qrWidth * (qrImg.height / qrImg.width));

      qrCanvas.width = qrWidth;
      qrCanvas.height = qrHeight;

      qrCtx.drawImage(qrImg, 0, 0, qrWidth, qrHeight);

      printer.addImage(
        qrCtx,
        0,
        0,
        qrWidth,
        qrHeight,
        printer.COLOR_1,
        printer.MODE_MONO,
        printer.HALFTONE_DITHER,
        1
      );

      printer.addFeedLine(1);
    }
    printer.addTextSize(1, 1);

    // ==== FOOTER ====
    printer.addTextAlign(printer.ALIGN_CENTER);
    printer.addText("Thank you for shopping please visit again!\n");
    printer.addFeedLine(1);
    printer.addTextFont(printer.FONT_C);
    printer.addTextSize(1, 1);
    printer.addTextAlign(printer.ALIGN_LEFT);
    printer.addText("PRINT TIME : " + dayjs().format("hh:mm:ss A") + "\n");
    printer.addFeedLine(2);
    printer.addCut(printer.CUT_FEED);

    // ---- SEND TO PRINTER ----
    printer.send();
  }
  // }
};
